module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._v("Calendar Filters")]), _vm._v(" "), _c('checkbox', {
    on: {
      "input": _vm.filtersChanged
    },
    model: {
      value: (_vm.getCurrentAccountType.isToHideCalendarEventCanceled),
      callback: function($$v) {
        _vm.$set(_vm.getCurrentAccountType, "isToHideCalendarEventCanceled", $$v)
      },
      expression: "getCurrentAccountType.isToHideCalendarEventCanceled"
    }
  }, [_vm._v("\n        Hide canceled events\n    ")]), _vm._v(" "), _c('checkbox', {
    on: {
      "input": _vm.filtersChanged
    },
    model: {
      value: (_vm.getCurrentAccountType.isToHideCalendarEventEmpty),
      callback: function($$v) {
        _vm.$set(_vm.getCurrentAccountType, "isToHideCalendarEventEmpty", $$v)
      },
      expression: "getCurrentAccountType.isToHideCalendarEventEmpty"
    }
  }, [_vm._v("\n        Hide events with no bookings\n    ")]), _vm._v(" "), _c('checkbox', {
    on: {
      "input": _vm.filtersChanged
    },
    model: {
      value: (_vm.getCurrentAccountType.showHidenProductsOnCalendar),
      callback: function($$v) {
        _vm.$set(_vm.getCurrentAccountType, "showHidenProductsOnCalendar", $$v)
      },
      expression: "getCurrentAccountType.showHidenProductsOnCalendar"
    }
  }, [_vm._v("\n        Show Plan Products\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7dbae7e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dbae7e4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/filters/calendarFilters.vue
// module id = 2740
// module chunks = 0